import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading, Button } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';
import { InsuranceInfoType } from 'scenes/common/types';

import LinkButtonSecondary from 'components/ButtonLinkSecondary';
import LinkButtonPrimary from 'components/ButtonLinkPrimary';

import { TermsAndConditionsModal } from './TermsAndConditionsModal';

const Container = styled.div`
  background-color: ${THEME.BACKGROUND.WHITE};
  text-align: center;
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid ${THEME.FIELD.BORDER.DEFAULT};
  padding: 1rem;
  margin: 0.5rem;

  .c-btn--link {
    color: ${THEME.LINK.ACCESSIBLE} !important;
    font-size: 14px !important;
  }
`;

const PromoWrapper = styled.div`
  background-color: ${THEME.BACKGROUND.CARD};
  border-radius: 1.75rem;
  padding: 0.2rem;
  width: 9rem;
  margin: auto;
`;

const ImageWrapper = styled.div`
  height: 5rem;
`;

const Image = styled.img`
  margin-bottom: -2rem;
  height: 4rem;
`;

const LinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  width: 15rem;
  margin: auto;
`;

const InsuranceCard: FunctionComponent<{
  insurance: InsuranceInfoType;
}> = ({ insurance }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    name,
    image,
    links,
    saveOnlineText,
    termsAndConditionsElement,
    termsModalHeading,
    termsLinkText,
  } = insurance;

  return (
    <Container>
      <Heading size={4}>{name} Insurance</Heading>
      <ImageWrapper>
        <Image src={image} tabIndex={-1} alt={name} />
      </ImageWrapper>
      <PromoWrapper>
        <TextSmall weight={600} margin={{ bottom: 0 }}>
          {saveOnlineText}
        </TextSmall>
      </PromoWrapper>
      <Button
        link
        size="xs"
        margin={{ top: 2, bottom: 3 }}
        onClick={() => setShowModal(true)}
        align="center"
      >
        {termsLinkText}
      </Button>
      <LinksWrapper>
        <LinkButtonSecondary
          url={links.findOutMore}
          label="Find out more"
          ariaLabel={`Find out more about ${name} insurance`}
        />
        <LinkButtonPrimary
          url={links.getQuote}
          label="Get a quote"
          ariaLabel={`Get a quote for ${name} insurance`}
        />
      </LinksWrapper>
      <TermsAndConditionsModal
        heading={termsModalHeading}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        termsAndConditionsElement={termsAndConditionsElement}
      />
    </Container>
  );
};

export default InsuranceCard;
